import { z } from "zod";

export const loginIntentDto = z.object({
  id: z.string(),
  creationDate: z
    .string()
    .transform((date) => new Date(date))
    .or(z.date()),
  useTrials: z.number(),
});

export type LoginIntent = z.infer<typeof loginIntentDto>;
